import React from "react";
import "./Footer.css";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaMobileAlt,
  FaGlobe,
  FaArrowUp,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../../assets/logo/greenland_footer.png";

const FooterSection = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Column 1: Logo & Contact */}
        <div className="footer-column">
          <div className="footer-logo">
            <img src={logo} alt="Website logo" />
          </div>
          <div className="contact-info">
            <div className="contact-item">
              <FaMapMarkerAlt className="icon" id="id-icon" />
              <span>
                Suite: 8/A&B, LilyPond Center, 3, R. K Mission Road, Motijheel,
                Dhaka-1000
              </span>
            </div>
            <div className="contact-item">
              <FaEnvelope className="icon" />
              <span>info@iconicgreenland.com</span>
            </div>
            <div className="contact-item">
              <FaGlobe className="icon" />
              <span>iconicgreenland.com</span>
            </div>
            <div className="contact-item">
              <FaMobileAlt className="icon" />
              <span>
                <strong>Hotline:</strong> 01937-900900
              </span>
            </div>
            <div className="contact-item">
              <FaPhoneAlt className="icon" />
              <span>Phone: 01803-030303</span>
            </div>
          </div>
        </div>

        {/* Column 2: Navigation */}
        <div className="footer-column" id="footer-column-page">
          <h3 className="footer-nav-header">Pages</h3>
          <ul className="li-links">
            <li>
              <Link to={"/"}>Home</Link>
            </li>
            <li>
              <Link to={"/about"}>About</Link>
            </li>
            <li>
              <Link to={"/gallery"}>Gallery</Link>
            </li>
            <li>
              <Link to={"/blogs"}>Blogs</Link>
            </li>
            <li>
              <Link to={"/contact-us"}>Contact</Link>
            </li>
            <li>
              <Link to={"/faq"}>FAQ</Link>
            </li>
            <li>
              <Link to={"/privacy-policy"}>Privacy policy</Link>
            </li>
          </ul>
        </div>

        {/* Column 4: Social & QR */}
        <div className="footer-column">
          <h3 className="footer-nav-header">Social Media</h3>
          <div className="social-icons">
            <a
              href="https://www.facebook.com/iconicgreenland/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>

            <a href="#" target="_blank" rel="noopener noreferrer">
              {" "}
              <FaLinkedinIn />
            </a>

            {/* <a href="http://" target="_blank" rel="noopener noreferrer"><FaTwitter /></a> */}

            <a
              href="https://www.youtube.com/@iconicgreenland"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube />
            </a>

            {/* <a href="http://" target="_blank" rel="noopener noreferrer"> <FaPinterestP /></a> */}

            <a
              href="https://mail.google.com/mail/?view=cm&fs=1&to=info@iconicgreenland.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaEnvelope />
            </a>
          </div>
          <h3 className="footer-nav-header">Scan for QR</h3>
          <div className="qr-container">
            {/* Replace with actual QR image path */}
            <img src="/QR.jpg" alt="" />
          </div>
          <p className="qr-text">
            To scan with your camera's default photo mode, point your camera at
            a QR code.
          </p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="bottom-content">
          <p>Copyright © 2026 Iconic Greenland. All Rights Reserved.</p>
          <p>
            Designed & Developed by{" "}
            <a
              href="https://iconicsoftltd.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              Iconic Soft Ltd.
            </a>
          </p>
          <div className="bottom-links">
            <Link to={"/privacy-policy"}>Privacy Policy</Link>
            <Link to={"/terms-and-conditions"}>Terms & conditions</Link>
            <Link to={"/site-map"}>Sitemap</Link>
          </div>
        </div>
        <a href={"#"} className="scroll-top">
          <FaArrowUp />
        </a>
      </div>
    </footer>
  );
};

export default FooterSection;
